import React from 'react'
import NavBar from './components/NavBar'
import Login from './components/user/Login'
import Notification from './components/Notification'
import Loading from './components/Loading'
import Profile from './components/user/Profile'
import BottomNav from './components/travel/BottomNav'
import { Box, Stack, Toolbar } from '@mui/material'
import AppRoutes from './routes/AppRoutes'
import OkCancelDialog from './components/OkCancelDialog'
const App = () => {

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#fff', overflow: 'auto' }} pl={2} pr={2} >
      <Loading />
      <Profile />
      <Notification />
      <OkCancelDialog />
      <Login />

      <Stack direction="column" justifyContent={'top'} style={{ minHeight: '100vh' }}>
        <NavBar />
        {/*<Stack direction='row' spacing={0} justifyContent='space-between' flexGrow={1} pt={2} pb={2}>
          {/*<Toolbar /> {/* Solamente se está añadiendo para que todos los elementos por debajo de navbar se muestren despues de esa altura*/}
          <AppRoutes />
        {/*</Stack>  */}
        {/*<Box bgcolor='orange' borderRadius={0} p={2} mb={0} style={{border: '1px solid #eee', boxShadow: '2px 4px 6px #ddd'}}>
          <h2>Footer</h2>
        </Box>*/}
      </Stack>
    </Box>
  )
}

export default App